import { createPaginator } from "@smithy/core";
import { ListStreamProcessorsCommand, } from "../commands/ListStreamProcessorsCommand";
import { RekognitionClient } from "../RekognitionClient";
export const paginateListStreamProcessors = createPaginator(RekognitionClient, ListStreamProcessorsCommand, "NextToken", "NextToken", "MaxResults");
